import React from 'react';
import { connect } from 'react-redux';
import { Modal, Tab } from 'semantic-ui-react';
import { showRevenueModal, hideRevenueModal } from '../../redux/actions/modals';
import VarianceHistory from '../SiteInstallations/VarianceHistory';
import CollectionPerformance from '../SiteInstallations/CollectionPerformance';
import CollectionBanking from '../SiteInstallations/CollectionBanking';

class RevenueModal extends React.Component {

  onClose = () => {
    this.props.hideRevenueModal().then(() => this.props.modal.onClose())
  }

  render() {
    const { isSiteVariance, open, selectedSite, operator, selectedVarianceType } = this.props.modal;
    const { siteId, siteDisplay } = selectedSite;

    const panes = [
      {
        menuItem: 'Collection - Banking',
        pane: <Tab.Pane><CollectionBanking siteId={siteId} operator={operator} /></Tab.Pane>
      },
      {
        menuItem: 'Collection - Net Income',
        pane: <Tab.Pane><CollectionPerformance siteId={siteId} operator={operator} /></Tab.Pane>
      }
    ]



    return (
        <Modal
          open={open}
          onClose={this.onClose}
          size='fullscreen'
          closeIcon
          style={{ height: "60%"}}
        >
          <Modal.Header>{ isSiteVariance ? `Machine Variance History - ${siteDisplay}` : `Collection Summary - ${siteDisplay}` }</Modal.Header>
          <Modal.Content className="h-100 gs-flex-container-vertical">
            { isSiteVariance ? 
              <VarianceHistory siteId={siteId} selectedVarianceType={selectedVarianceType} operator={operator} />
            :
              <Tab renderActiveOnly={false} panes={panes} className="flex-stretch gs-flex-container-vertical mt-1" />
            }
          </Modal.Content>
        </Modal>
    )
  }
}

const mapStateToProps = state => {
	return {
    modal: state.revenueModal,
  };
};

export default connect(mapStateToProps, { showRevenueModal, hideRevenueModal })(RevenueModal);


